<template>
  <li
    ref="norticListItem"
    class="nortic-list-item"
  >
    <div
      ref="norticListContainer"
      class="nortic-list-item-container"
      :tabindex="tabIndex"
      :style="itemContainerStyles"
      :disabled="isDisabled"
      :active="isActive"
      @keydown.enter.self.prevent="emitClickEvent"
      @keydown.space.self.prevent="emitClickEvent"
      @keydown.down.self.prevent="emitFocusNextItem"
      @keydown.up.self.prevent="emitFocusPreviousItem"
      @click="emitClickEvent"
      @focus="emitItemHasFocus"
    >
      <slot
        :item-data="itemData"
        :is-active="isActive"
        :is-disabled="isDisabled"
        :is-parent="isParent"
        :label="label"
        :level="level"
      >
        {{ label }}
      </slot>
    </div>
    <ul
      v-if="children && children.length > 0"
    >
      <template v-for="(childItem, index) in children">
        <NorticListItem
          ref="children"
          :key="childItemKeyMapper(childItem, index)"
          :item-data="childItem"
          :label="childItemLabelMapper(childItem, index)"
          :is-disabled="childItemDisabledMapper(childItem, index)"
          :is-active="childItemSelectedMapper(childItem, index)"
          :children="childItemChildrenMapper(childItem, index)"
          :child-item-children-mapper="childItemChildrenMapper"
          :child-item-key-mapper="childItemKeyMapper"
          :child-item-label-mapper="childItemLabelMapper"
          :child-item-disabled-mapper="childItemDisabledMapper"
          :child-item-selected-mapper="childItemSelectedMapper"
          :level="level + 1"
          @click="emitChildClickEvent(childItem, index)"
          @child-click="emitChildClickEvent"
          @focus-next-item="emitFocusNextItem"
          @focus-previous-item="emitFocusPreviousItem"
          @item-has-focus="emitChildItemHasFocus"
        >
          <template
            v-for="slot in slots"
            #[slot]="scope"
          >
            <slot
              :name="slot"
              v-bind="scope"
            />
          </template>
        </NorticListItem>
      </template>
    </ul>
  </li>
</template>

<script>
import NorticListItemMixin from '@/components/common/data/nortic-list/mixin/norticListItem';

export default {
  name: 'NorticListItem',
  mixins: [NorticListItemMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    childItemSelectedMapper: {
      type: Function,
      default: () => false,
    },
  },
  computed: {
    tabIndex() {
      return this.isDisabled
        ? -1
        : 0;
    },
  },
  methods: {
    emitItemHasFocus() {
      this.$emit('item-has-focus', this.$refs.norticListContainer);
    },
    emitChildItemHasFocus(ref) {
      this.$emit('item-has-focus', ref);
    },
    emitFocusNextItem() {
      this.$emit('focus-next-item');
    },
    emitFocusPreviousItem() {
      this.$emit('focus-previous-item');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/styles/_animations.scss';

  .nortic-list-item {
    &:not(:last-child) {
      &::after {
        content: '';
        position: absolute;
        width: calc(100% - 1em);
        height: 0.06em;
        left: 0.5em;
        bottom: 0;
        background: var(--border-color-hex);
      }
    }

    position: relative;
    background: var(--input-bg-hex);
    overflow: hidden;

    .nortic-list-item-container {
      &[disabled] {
        opacity: 0.5;
        cursor: default;
        pointer-events: none;
      }

      &:focus,
      &:hover {
        &:not([disabled]) {
          background: var(--input-hover-bg-hex);
        }
      }

      &:focus {
        outline: none;
      }

      &:active,
      &[active] {
        background: var(--input-active-bg-hex);
      }

      &[active] {
        &:focus,
        &:hover {
          background:
            linear-gradient(rgba(var(--input-active-bg-rgb), 0.6), rgba(var(--input-active-bg-rgb), 0.6)),
            linear-gradient(rgba(var(--input-hover-bg-rgb), 0.9), rgba(var(--input-hover-bg-rgb), 0.9));
        }
      }

      &:not(:last-child) {
        &::after {
          content: '';
          position: absolute;
          width: calc(100% - 1em);
          height: 0.06em;
          left: 0.5em;
          bottom: 0;
          background: var(--border-color-hex);
        }
      }

      position: relative;
      padding: 0.5em 1em;
      cursor: pointer;
    }

    ul {
      padding: 0;

      li {
        padding: 0;
      }
    }
  }
</style>
